import { createGetEndpoint } from '@sonar-software/sonar-http';
import { DataSecurityApplication } from '@types';

export type GetDataSecurityApplicationByIdRequest = {
	applicationId: number;
};

export const getDataSecurityApplicationById = createGetEndpoint<
	GetDataSecurityApplicationByIdRequest,
	DataSecurityApplication
>(({ applicationId }) => `/api/v3/data-security/applications/${applicationId}`);
